import 'babel-polyfill'
import 'vue-pure-lightbox/dist/VuePureLightbox.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import moment from "moment"
import eventBus from './event-bus';
import api from "./api"
import helpers from "./helpers"
import VueClipboard from 'vue-clipboard2'
import GoogleAuth from 'vue-google-oauth'
import Vue2Editor from "vue2-editor";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
require('vue2-animate/dist/vue2-animate.min.css')
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


Vue.filter('capitalizeFirstLetter', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
})
Vue.filter('phone', function (phone) {
  phone = phone.replace("+1", "");
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});
Vue.filter('fromNow', function (value) {
  if (!value) return 'Never'
  return moment(value).fromNow()
})

Vue.filter('dateFormat', function (value) {
  if (!value) return 'Never'
  return moment(value).format('MMMM Do YYYY')
})

Vue.filter('decimal', function (v) {
  if (!v) {
    return '0.00'
  }
  return (v / 100).toFixed(2)
})

Vue.filter('limit_30', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 30) + (value.length > 30 ? "..." : "")
})
Vue.filter('limit_35', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 35) + (value.length > 35 ? "..." : "")
})
Vue.filter('limit_50', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 50) + (value.length > 50 ? "..." : "")
})

Vue.filter('limit_40', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 40) + (value.length > 40 ? "..." : "")
})

Vue.filter('limit_20', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 20) + (value.length > 20 ? "..." : "")
})

Vue.filter('limit_15', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 15) + (value.length > 15 ? "..." : "")
})

Vue.filter('limit_100', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 100) + (value.length > 100 ? "..." : "")
})

Vue.filter('limit_200', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 200) + (value.length > 200 ? "..." : "")
})

Vue.filter('limit_150', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 150) + (value.length > 150 ? "..." : "")
})

Vue.use(GoogleAuth, {
  client_id: '103405318878-79sj8lcf82bfvg8cv0rdghprdt83jk86.apps.googleusercontent.com'
})
Vue.googleAuth().load()
Vue.googleAuth().directAccess()

Vue.use(Vue2Editor);
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$helpers = helpers;
Vue.prototype.$api = api;
Vue.prototype.$google = Vue.googleAuth()

async function check_notifications() {
  if (store.getters['isLoggedIn']) {
    await store.dispatch('load_notifications')
  }
  setTimeout(check_notifications, 20000)
}
setTimeout(check_notifications, 5000)

async function startup() {
  console.time("loadStore")
  console.time("loadApp")
  await store.dispatch('load')
  console.timeEnd("loadStore")
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
  console.timeEnd("loadApp")
}
startup()